import { useEffect, useRef } from "react";

export function useInactivityTimeout(
  callback: () => void,
  timeout: number = 1800000
) {
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(callback, timeout);
  };

  useEffect(() => {
    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
    ];
    const handleActivity = () => resetTimer();

    for (const event of events) {
      window.addEventListener(event, handleActivity);
    }

    resetTimer(); // Start the initial timer

    return () => {
      for (const event of events) {
        window.removeEventListener(event, handleActivity);
      }
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [callback, timeout]);
}
